import { render, staticRenderFns } from "./ElectionType.vue?vue&type=template&id=46cdc4bc&scoped=true&"
import script from "./ElectionType.vue?vue&type=script&lang=js&"
export * from "./ElectionType.vue?vue&type=script&lang=js&"
import style0 from "./ElectionType.vue?vue&type=style&index=0&id=46cdc4bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cdc4bc",
  null
  
)

export default component.exports